import { apiError } from '../apiError';
import axiosInstance from '../axios.config';
import { ApiResponse } from 'types';

/**
 * Agent capability catalog — the dropdown options for the agent-config editor.
 * Backend: core-service GET /api/v1/agent-catalog. Options are grouped by dimension
 * (LLM_PROVIDER, LLM_MODEL, TTS_PROVIDER, TTS_VOICE, TTS_MODEL, STT_PROVIDER, STT_MODEL,
 * LANGUAGE, MEDIA_FORMAT), most-used first. A model/voice row carries its parent
 * `provider` so the editor can chain the dropdowns.
 */
export interface CatalogOption {
  provider: string | null;
  value: string;
  label: string;
  source: 'SEED' | 'HARVESTED';
  usageCount: number;
}

export type AgentCatalog = Record<string, CatalogOption[]>;

export const agentCatalogService = {
  get: async (): Promise<ApiResponse<AgentCatalog>> => {
    try { return (await axiosInstance.get('/v1/agent-catalog')).data; }
    catch (e: any) { return apiError(e, 'Failed to load agent catalog'); }
  },
};
